import React, { useState, useEffect } from "react";
import "./Footer.css";
import xten from "../../assets/xten-logo-footer.png";
import facebook from "../../assets/faFacebookSquare.svg";
import linkedin from "../../assets/faLinkedin.svg";
import ig from "../../assets/ig.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    // ฟังก์ชันตรวจสอบขนาดหน้าจอ
    const handleResize = () => {
      if (window.screen.width <= 932) {
        setIsMobile(true); // ถ้าเป็นมือถือหรือขนาดเล็ก
      } else {
        setIsMobile(false); // ถ้าเป็นขนาดใหญ่
      }
    };

    // เรียกใช้เมื่อแสดงผลครั้งแรกและเวลาเปลี่ยนขนาดหน้าจอ
    handleResize();
    window.addEventListener("resize", handleResize);

    // ลบ event listener เมื่อ component ถูก unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="footer">
      <div className="footer-content">
        <div className="info-xten">
          <img src={xten} alt="" className="footer-logo" />
          <div>
            <div className="footer-location">
              <div className="text-head-location-footer">
                {t("footer_location")}
              </div>
              <div className="text-sub-location-footer">
                <div>{t("footer_location1")}</div>
                <div>{t("footer_location2")}</div>
              </div>
            </div>
            <div className="contact-footer">
              <div className="contact-footer-email">
                <div className="text-head-location-footer">
                  {t("footer_email")}
                </div>
                <div className="text-sub-location-footer">
                  {t("footer_location_email")}
                </div>
              </div>
              <div className="contact-footer-phone">
                <div className="text-head-location-footer">
                  {t("footer_phone")}
                </div>
                <div className="text-sub-location-footer">
                  {t("footer_location_phone")}
                </div>
              </div>
            </div>
          </div>
          <div className="footer-logo-something">
            <a
              href="https://www.facebook.com/xtentech"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebook} alt="" className="logo-app" />
            </a>
            <a
              href="https://www.linkedin.com/company/xten-technology-co-ltd/mycompany/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="" className="logo-app" />
            </a>
            <a
              href="https://www.instagram.com/xtentech.official/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ig} alt="" className="logo-app" />
            </a>
          </div>
        </div>
        {!isMobile && (
          <div className="main-menu">
            <div className="head-main-menu">{t("footer_main_menu")}</div>
                
            <div className="menu-xten">
              <div className="list-menu-xten">
              <Link to="/" style={{ textDecoration: "none" }}>
              <div className="sub-list-menu-xten">{t("footer_home")}</div>
                </Link>
                
                <div className="sub-list-menu-xten">
                  {t("navbar_sustain_x")}
                </div>
                <div className="sub-list-menu-xten">
                  {t("IoT_Solution_Platform")}
                </div>
                <div className="sub-list-menu-xten">{t("navbar_product")}</div>
                <div className="sub-list-menu-xten">{t("navbar_services")}</div>
              </div>
              <div className="list-menu-xten">
                <div className="sub-list-menu-xten">{t("navbar_about_as")}</div>
                <Link
                  to={{
                    pathname: "/news&events",
                    state: "All", // ส่ง selectedType หรือค่าที่ต้องการ
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <div className="sub-list-menu-xten">
                    {t("navbar_new_event")}
                  </div>
                </Link>

                <div className="sub-list-menu-xten">{t("navbar_contact")}</div>
                {/* <div className="sub-list-menu-xten">Console</div> */}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="footer-copy-rights">
        <div className="text-copy-rights">
          © 2022 xtentechnology. All Rights Reserved.
        </div>
        <div className="privacy-terms">
          <div className="text-copy-rights">Privacy Policy</div>
          <div className="text-copy-rights">Terms & Conditions</div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
